<template>
	<q-dialog v-model="dialog" full-width persistent transition-hide="fade-out">
		<div class="hris-modal edit-schedule-modal">
			<div class="hris-modal-header">
				<div>
					<h3 class="hris-modal-title">Update Schedule</h3>
					<p class="hris-modal-subtitle edit-schedule-note">Note: 24 hour format is required (Ex. 08:00-18:00)</p>
				</div>
			</div>
			<q-form ref="vForm" @submit="updateSchedule">
				<div class="hris-modal-body">
					<div class="hris-table-wrap">
						<table class="hris-table edit-schedule-table">
							<thead>
								<tr>
									<th v-for="(head) in rangeHeader" :key="head.name" class="text-center">{{ head.label }}</th>
								</tr>
							</thead>
							<tbody>
								<tr class="text-center caps">
									<td>{{ empID }}</td>
									<td class="text-center">{{ name }}</td>
									<td v-for="(sch,i) in schedules" :key="i">
										<input type="text" v-model="schedules[i].editsched" size="10" placeholder="00:00-00:00" required class="text-center caps edit-schedule-input">
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="hris-modal-footer">
					<q-btn unelevated class="hris-q-outline" label="Close" @click="closeModal"></q-btn>
					<q-btn unelevated class="hris-q-primary" label="Save" type="submit"></q-btn>
				</div>
			</q-form>
		</div>
	</q-dialog>
</template>
<script>
import axios from 'axios';
import mixins from '../../mixins';

export default {

	data() {
		return {
			hide:false,
			dialog: false,
			empID:'',
			name:'',
			rangeHeader:[],
			schedules:[],
			schedHolder:[],
			rangeHeaderHolder:[]
		}
	},

	created(){
		this.eventHub.$on('EditSchdule', this.editSchdule);
	},

	methods: {

		editSchdule:function(payload){

		//	alert(payload.status)
			this.dialog = payload.status
			this.rangeHeader = payload.header
			this.empID = payload.emp.employee_id
			this.name = payload.emp.name
			this.schedules = payload.emp.schedule
		},


		updateSchedule:function(){
			this.schedHolder = []
			for(let i in this.schedules){
				this.schedHolder.push(this.schedules[i].editsched)
			}
			this.rangeHeaderHolder = []
			for(let i in this.rangeHeader){
				this.rangeHeaderHolder.push(this.rangeHeader[i].name)
			}

			let formData  = new FormData()
			formData.append("empID",this.empID);
			formData.append("dateRange",this.rangeHeaderHolder);
			formData.append("schdules", this.schedHolder);

			axios.create({
				baseURL : this.apiUrl,
				headers : {'Authorization' : `Bearer ${this.token}`}
			}).post('/schedule/manual',formData)
			.then((res) => {
				this.eventHub.$emit('UpdateSchdule');
				this.dialog = false;
				this.$q.notify({
					message: 'Schedule Updated!',
					color: 'green',
					position:'center',
					actions: [
				{ label: 'Dismiss', color: 'white', handler: () => { /* ... */ } }
				]
			})
			}).catch((error) => {
				console.log(error.response)
			})
		},

		submitGroup:function(){

		},

		closeModal:function(){
			this.dialog = false
		}
	}
}
</script>
<style lang="css" scoped>
.edit-schedule-modal {
	max-width: 100%;
	width: auto;
}

.edit-schedule-note {
	color: #a61b12;
}

.edit-schedule-table th,
.edit-schedule-table td {
	white-space: nowrap;
}

.edit-schedule-input {
	width: 100%;
	min-width: 110px;
	font-size: 0.9375rem;
	text-align: center;
	padding: 8px 6px;
	border: 1px solid var(--hris-border, #e2e5ea);
	border-radius: var(--hris-radius-sm, 10px);
	font-family: inherit;
}

.edit-schedule-input:focus {
	outline: none;
	border-color: var(--hris-accent, #2f8f62);
}
</style>
